import React, { useState, useEffect, useContext } from "react"
import { UserContext } from '../layouts/UserContext';
import { Link } from "gatsby"
import ReactTooltip from "react-tooltip"
import ReactWOW from "react-wow"
import Collapsible from "react-collapsible"
import styled from "styled-components"

const PriceItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  background: #f8f8fa;
  padding: 15px;
  font-size: 13px;

  position: relative;

  i {
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 1rem;
  }

  i:hover {
    cursor: pointer;
  }

  h5 {
    font-size: 16px;
    color: #222d39;
  }

  h5:hover {
    color: #f05123;
  }

  .price-active {
    color: #f05123;
  }
`

const Comparison = () => {

  const location = useContext(UserContext)

  const currency = location 

  return (
    <section className="pricing_area_four pricing_main_padding">
      <ReactTooltip />
      <div className="container pricing_container">
        <div className="hosting_title security_title text-center .intro">
          <ReactWOW animation="fadeInUp" delay="0.2s">
            <h2>
              Feature Comparison
              <span>
                The most robust suite of safety and compliance management tools
                on the market.
              </span>
            </h2>
          </ReactWOW>
          <p className="f_400 f_size_16 l_height30 mb_20">
            And it costs less than a hot cup of coffee! Try our <b>Standard</b> plan to put our full suite of features to the test, or get your feet wet with our <i>Free</i> plan’s limited feature offerings.
          </p>
        </div>
        <div className="price_info_two ">
          <div className="price_head">
            <div className="p_head time">
              <h4>Features</h4>
            </div>
            <div className="p_head">
              <p>Free</p>
              <h5>$0 </h5>
              <p>per month per user</p>
            </div>
            <div className="p_head">
              
              {currency === "US" || currency === undefined ? (
                <>
                  {" "}
                  <p>Standard</p>
                  <h5>$3</h5>
                  <p>
                    (USD) / month per user
                    <br />
                    (minimum 3 users)
                  </p>
                </>
              ) : null}

{currency !== 'US' && currency !== 'CA' && currency !== undefined ? (
                <>
                  {" "}
                  <p>Standard</p>
                  <h5>$3</h5>
                  <p>
                    (USD) / month per user
                    <br />
                    (minimum 3 users)
                  </p>
                </>
              ) : null}

              {currency === "CA" ? (
                <>
                  {" "}
                  <p>Standard</p>
                  <h5>$4</h5>
                  <p>
                    (CAD) / month per user
                    <br />
                    (minimum 3 users)
                  </p>
                </>
              ) : null}
            </div>
          </div>

          {/* Training */}

          <div className="price_body">
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Training Courses</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Training Courses</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Access a library of 80+ courses to train your workers or create your own courses with custom content and quiz questions
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>

              
            </div>

             {/* Policies */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Policies</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Policies</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Host your organization’s policies with version control and assign them to your workers to view and acknowledge
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>      

            {/* Procedures */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Procedures</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Procedures</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Administer your safety procedures and track who has viewed them
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

           {/* Certificates */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Certificates</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Certificates</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    House certifications for your workers, internal or third party, and track expirations
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>
            
            {/* Competencies */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Competencies</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Competencies</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Assure your workers are competent by compiling prerequisites and performance assessments in one tool
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

             {/* Incident Tracking */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Incident Tracking</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Incident Tracking</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Track your organization’s incidents, near misses, and hazard IDs in one spot
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Inspections */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Inspections</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Inspections</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Build and schedule custom inspections on your assets and locations, then assign action items as follow-up
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div> 
            </div>      
             {/* Safety Meetings */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Safety Meetings</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Safety Meetings</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Create meeting types, assign facilitators, and invite workers to attend important discussions
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div> 
            </div>

             {/* Forms */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Forms</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Forms</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Provide your workers with the forms your organization uses and collect digital submissions
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Bulletins */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Bulletins</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Bulletins</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Keep your workers up-to-date on alerts, issues, and updates and track readership
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>
            {/* Worker Management */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Worker Management</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Worker Management</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Create and manage your workers and monitor their compliance and ongoing tasks through a centralized hub
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>
            
            {/* Positions & Roles */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Positions & Roles</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Positions & Roles</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Provide structure to your organization by building your positions and roles and assigning tasks through them
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>      
            {/* Locations & Divisions */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Locations & Divisions</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Locations & Divisions</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Create the locations and organizational divisions within your organizations to streamline managing people and workflows
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>
            
            {/* Assets */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Asset Management</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Asset Management</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Manage your organization's physical assets, from gas detectors to company vehicles to wellsites
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Surveys */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Surveys</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Surveys</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Deploy surveys to your workers for feedback on their feelings on your organization, allowing anonymous responses
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>      
          
          {/* Culture & Recognition */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Culture & Recognition</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Culture & Recognition</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Recognize your workers for jobs well done by providing laughs, kudos, and rewards, and celebrate their tenure with your organization
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Safety Data Sheets */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Safety Data Sheets</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Safety Data Sheets</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Build your SDS manual with materials used in your workplace, ensuring your workers have the information they need anywhere they are
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>
                  {/* Audit Preparation */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Audit Preparation</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Audit Preparation</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Get ready for an audit using our library of audit protocols, catching and correcting deficiencies before an auditor does
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>


            {/* Worksite Screening */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Worksite Screening</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Worksite Screening</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Screen workers and visitors as they access your worksites with custom questionnaires and access logs
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>

              {/* WorkerID */}
            </div>
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>WorkerID</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">WorkerID</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Access compliance data on-the-go with the WorkerID mobile app
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* No Ads */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Ad-free</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Ad-free</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>Get an ad-free experience, removing ads from dashboards</div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* SMS Notifications */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>SMS Notifications</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">SMS Notifications</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Send SMS notifications for Bulletins, Alerts, Action Items, Scheduled Training, and Whistleblower reports to ensure a rapid response (Canada and USA only)
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Icon" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Custom Branding */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Custom Branding</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Custom Branding</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Customize the colours and appearance of your dashboards, add a company logo, and tailor a custom login/signup page for new workers
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Icon" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>

             
            </div>
                  {/* Onboarding Support */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Onboarding Support</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Onboarding Support</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Have the Workhub team import your workers, positions, locations, and assets and easily update your workers' compliance through copies of their previously completed training
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Icon" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>

             
            </div>
             {/* Advanced Reporting */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Advanced Reporting</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Advanced Reporting</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Reach the next level in reporting with large, exhaustive data downloads including matrix reports, ZIP files of Inspections and Certificates submissions, and Policy manuals 
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Icon" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>
             {/* Excel data exports */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Excel Data Exports</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Excel Data Exports</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Export your data from Workhub in Excel formats for easy, practical use outside the software
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Icon" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>     
             {/* PDFs */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Watermark-free PDFs</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Watermark-free PDFs</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Download your data for submission to clients as easy-to-read, watermark-free PDF reports
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Icon" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div> 
            {/* Larger Uploads */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Larger Uploads</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Large Uploads</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Upload larger documents and images throughout Workhub with less limitation on file size
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Line" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Phone Support */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Live Phone Support</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Live Phone Support</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Get immediate help from real people in addition to priority email and chat support
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close line" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Custom Permissions */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Custom Permissions</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Custom Permissions</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Tailor your workers' visibility and access with an extra level of detail beyond the defaults
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Line" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Access Limitation */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Access Limitation</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Access Limitation</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>Restrict what your workers can see in Workhub based on their Division or Location</div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Line" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Location Assignment */}
            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Location Assignment</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Location Assignment</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>Add an extra level of specificity in assigning items to your workers by including both position and location</div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img src="/app-icons/layout-icons/close-line.svg" alt="Close Line" />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>

            {/* Prime Contractor Support */}

            <div className="pr_list">
              <PriceItem>
                <Collapsible
                  trigger={
                    <div>
                      <h5>Prime Contractor Support</h5>
                      <i className="ti-plus">+</i>
                    </div>
                  }
                  triggerWhenOpen={
                    <div>
                      <h5 className="price-active">Prime Contractor Support</h5>
                      <i className="price-active">-</i>
                    </div>
                  }
                  transitionTime={200}
                >
                  <div>
                    Host your organization's company/project orientation for all Working accounts to view and review its global compliance
                  </div>
                </Collapsible>
              </PriceItem>
              <div className="price_item" data-title="Free">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/close-line.svg"
                    alt="Close Line"
                  />
                </h5>
              </div>
              <div className="price_item" data-title="Standard">
                <h5 className="check">
                  <img
                    src="/app-icons/layout-icons/green-checkmark-line.svg"
                    alt="Checkmark"
                  />
                </h5>
              </div>
            </div>     

            <div className="pr_list">
              <div className="price_item"></div>
              <div className="price_item">
                <Link to="/signup/" className="price_btn btn_hover">
                  Choose Free
                </Link>
              </div>
              <div className="price_item">
                <Link to="/signup/" className="price_btn btn_hover">
                  Choose Standard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Comparison